<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Safes withdrawals')"
          :description="$t('From here you can control safes withdrawals')"
        />
        <indexTable
          :searchText="$t('Search for withdrawals')"
          :emptyTableText="$t('There are no withdrawals operations')"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="$checkRole('safes_withdrawals_add')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('Situation'), value: '' },
            { title: $t('All'), value: '' },
            { title: $t('Draft'), value: 0 },
            { title: $t('Approved'), value: 1 }
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('Operation'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'safe_id',
              title: $t('Safe'),
              type: 'link',
              to: 'safe',
              sort: true,
              link: true
            },
            {
              column: 'date',
              title: $t('Withdrawals date'),
              type: 'text',
              sort: true
            },
            {
              column: 'description',
              title: $t('Thats about'),
              type: 'text',
              sort: true
            },
            {
              column: 'cost',
              title: $t('Amount'),
              type: 'text',
              sort: true
            },
            {
              column: 'user_name',
              title: $t('Responsible name'),
              type: 'text',
              sort: true
            },
            {
              column: 'status',
              title: $t('Situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('Draft'), value: 0, color: 'dark' },
                { title: $t('Approved'), value: 1, color: 'success' }
              ]
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'show' },
                {
                  name: 'edit',
                  role: $checkRole('safes_withdrawals_edit')
                },
                { name: 'file' },
                { name: 'printSafesWithdrawal', role: true },
                {
                  name: 'delete',
                  role: $checkRole('safes_withdrawals_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/safesWithdrawals'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
